import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { FundType } from '../../../../../../models/transactions/fund-type';
import { VariableBenefitPaymentChangeSubmission } from '../../../../../../models/submissions/variable-benefit-payment-change-submission';
import { VariableBenefitPaymentChangeSubmissionData } from '../../../../../../models/submissions/variable-benefit-payment-change-submission-data';
import { WithdrawalInstruction } from '../../../../../../models/submissions/withdrawal-instruction';
import { TrackByUtils } from '../../../../../../utils/track-by-utils';

@Component({
  selector: 'app-update-vb-payments-withdrawal-instructions-review-card',
  templateUrl: './update-vb-payments-withdrawal-instructions-review-card.component.html',
  styleUrls: ['./update-vb-payments-withdrawal-instructions-review-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateVbPaymentsWithdrawalInstructionsReviewCardComponent implements OnChanges {
  @Input({ required: true }) submission!: VariableBenefitPaymentChangeSubmission;
  @Input() fundTypes: FundType[] = [];

  public hasChanges = false;
  public currentInstructions: WithdrawalInstruction[] = [];
  public newInstructions: WithdrawalInstruction[] = [];
  public displayInstructions: WithdrawalInstruction[] = [];
  public trackByIndex = TrackByUtils.trackByIndex;

  public ngOnChanges(): void {
    const previous = this.submission?.previous ?? null;
    const newData = this.submission?.new ?? null;

    this.currentInstructions = this.toActiveInstructions(previous);
    this.newInstructions = this.toActiveInstructions(newData);
    this.hasChanges =
      previous !== null &&
      newData !== null &&
      !this.areInstructionsEquivalent(this.currentInstructions, this.newInstructions);
    // No-changes view mirrors the create card; prefer the new side when present.
    this.displayInstructions = newData !== null ? this.newInstructions : this.currentInstructions;
  }

  private toActiveInstructions(data: VariableBenefitPaymentChangeSubmissionData | null): WithdrawalInstruction[] {
    const instructions = (data?.withdrawalInstructions ?? []).filter(i => i.percentage > 0);
    return instructions
      .map(instruction =>
        Object.assign(new WithdrawalInstruction(), instruction, {
          fund: instruction.fund ?? this.fundTypes.find(f => f.id === instruction.fundId) ?? null!
        })
      )
      .sort((a, b) => (a.fund?.name ?? '').localeCompare(b.fund?.name ?? ''));
  }

  private areInstructionsEquivalent(a: WithdrawalInstruction[], b: WithdrawalInstruction[]): boolean {
    if (a.length !== b.length) return false;
    const byFundId = new Map(b.map(i => [i.fundId, i.percentage]));
    return a.every(i => byFundId.get(i.fundId) === i.percentage);
  }
}
